import { useEffect, useMemo } from "react";

import useEnvironments from "Hooks/useEnvironments";
import { getVariables } from "Reducers/environment/settings/variable";
import { useAppDispatch, useAppSelector } from "Store/hooks";

export function useLoadEnvironmentVariables({
  organizationId,
  projectId
}: {
  organizationId: string;
  projectId: string;
}) {
  const dispatch = useAppDispatch();
  const environments = useEnvironments(projectId);

  const envVariables = useAppSelector(
    ({ environmentVariable }) => environmentVariable || {}
  );

  const loading = envVariables.loading;
  const errors = envVariables.errors;
  const status = envVariables.status;

  useEffect(() => {
    if (environments) {
      Object.keys(environments)?.forEach(env =>
        dispatch(
          getVariables({
            organizationId,
            projectId,
            environmentId: env
          })
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const multipleEnvironments = useMemo(
    () =>
      Object.keys(environments || {})?.map(env => {
        return {
          [env]: Object.values(
            envVariables.data?.[organizationId]?.[projectId]?.[env] ?? {}
          )
        };
      }),
    [environments, envVariables, projectId, organizationId]
  );

  return {
    loading,
    errors,
    status,
    multipleEnvironments
  };
}
